import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import Locations from "@/pages/Locations";

export const Route = createFileRoute("/_site/locations/")({
  head: () => ({
    ...seo({
      title: "Service Areas | Kodiak Structures & Exteriors",
      description:
        "Roofing, siding and exterior services in Blaine, Coon Rapids, Plymouth, Woodbury, St. Paul, Rochester, Duluth and communities throughout Minnesota.",
      path: "/locations",
    }),
  }),
  component: Locations,
});
